import { ReactNode } from "react";
import PublicNavbar from "./PublicNavbar";
import PublicFooter from "./PublicFooter";
import { InteractiveBackground } from "./InteractiveBackground";
import SimpleChatWidget from "../chat/SimpleChatWidget";
import CustomCursor from "./home/CustomCursor";
import { useLanguage } from "@/contexts/LanguageContext";

interface PublicLayoutProps {
    children: ReactNode;
}

const PublicLayout = ({ children }: PublicLayoutProps) => {
    const { dir } = useLanguage();

    return (
        <div className="min-h-screen flex flex-col relative selection:bg-primary/20 bg-background" dir={dir}>
            <InteractiveBackground />

            <div className="relative z-10 flex flex-col min-h-screen">
                <PublicNavbar />
                <main className="flex-grow">
                    {children}
                </main>
                <PublicFooter />
            </div>

            {/* Floating Simple Mode Chat Widget */}
            <SimpleChatWidget />

            {/* v2 custom cursor — desktop only, respects prefers-reduced-motion */}
            <CustomCursor />
        </div>
    );
};

export default PublicLayout;
